<template>
  <div class="container">
    <el-card shadow="never" class="card">
      <customize-form-info ref="generalData" :infoData="_generalData" />
    </el-card>
    <el-card
      header="Business Summary"
      shadow="never"
      class="card"
      style="line-height: 24px"
    >
      {{ (this.detail.summaryVO && this.detail.summaryVO.text) || '' }}
    </el-card>
    <el-card
      header="Contact and General Information"
      shadow="never"
      class="card"
    >
      <customize-form-info ref="contactData" :infoData="_contactData" />
    </el-card>
    <el-card header="Score Information" shadow="never" class="card">
      <div class="scoreBox">
        <div class="leftBox">
          <div>
            <p>
              <span>
                Frisk Score:
                {{
                  this.detail.businessVO && this.detail.businessVO.friskScore
                }}
              </span>
              <span>
                As Of:
                {{
                  this.detail.businessVO &&
                  this.detail.businessVO.friskScoreDate
                }}
              </span>
            </p>
            <p>
              <span>
                Z Score:
                {{ this.detail.businessVO && this.detail.businessVO.zscore }}
              </span>
              <span>
                As Of:
                {{
                  this.detail.businessVO && this.detail.businessVO.zscoreDate
                }}
              </span>
            </p>
          </div>
          <el-table
            :data="this.detail.friskhistoryVOList"
            style="margin-top: 80px"
            :stripe="true"
            header-row-class-name="table-header"
          >
            <el-table-column
              v-for="item in friskHistorySchema"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
            ></el-table-column>
          </el-table>
        </div>
        <div class="rightBox">
          <p style="margin-bottom: 20px">Frisk Score</p>
          <score-bar
            :scaleArr="[0, 2.5, 5, 7.5, 10]"
            :score="friskScore"
          ></score-bar>
          <v-chart :options="option" style="margin-top: 40px"></v-chart>
          <v-chart :options="ZscoreOption" style="margin-top: 40px"></v-chart>
        </div>
      </div>
    </el-card>
    <el-card header="Annual Financial Statements" shadow="never" class="card">
      <div class="annualTitle">
        <span style="font-weight: bold">* Balance sheet</span>
        <customize-button type="primary" @click="showDia = true">
          Save to Financial Report
        </customize-button>
      </div>
      <!--        table-->
      <!--      current asset-->
      <table-view
        :showPage="false"
        tableCardTitle="Current Assets"
        :tableModel="_colModel"
        :tableData="_currentAssetData"
      ></table-view>
      <!--     non current asset-->
      <table-view
        :showPage="false"
        tableCardTitle="Non-Current Assets"
        :tableModel="_colModel"
        :tableData="_nonCurrentAsset"
      ></table-view>
      <!--      current liabilities-->
      <table-view
        :showPage="false"
        tableCardTitle="Current Liabilities"
        :tableModel="_colModel"
        :tableData="_currentLiabilities"
      ></table-view>
      <!--      Non-Current Liabilities -->
      <table-view
        :showPage="false"
        tableCardTitle="Non-Current Liabilities"
        :tableModel="_colModel"
        :tableData="_nonCurrentLiabilities"
      ></table-view>
      <!--      Shareholders' Equity -->
      <table-view
        :showPage="false"
        tableCardTitle="Shareholders' Equity"
        :tableModel="_colModel"
        :tableData="_shareHolders"
      ></table-view>
      <!--      Supplemental Information-->
      <table-view
        :showPage="false"
        tableCardTitle="Supplemental Information"
        :tableModel="_colModel"
        :tableData="_suppleData"
      ></table-view>
      <!--  Cash Flow Statement  -->
      <div class="annualTitle">
        <span style="font-weight: bold">* Income Statement</span>
      </div>
      <!--    Income Statement  -->
      <table-view
        :showPage="false"
        tableCardTitle="Revenue"
        :tableModel="_colModel"
        :tableData="_revenueData"
      ></table-view>
      <!--      Operating Expense-->
      <table-view
        :showPage="false"
        tableCardTitle="Operating Expense"
        :tableModel="_colModel"
        :tableData="_expenseData"
      ></table-view>
      <!--      Non-Operating Expense/Income-->
      <table-view
        :showPage="false"
        tableCardTitle="Non-Operating Expense/Income"
        :tableModel="_colModel"
        :tableData="_noeiData"
      ></table-view>
      <!--      Extraordinary Items -->
      <table-view
        :showPage="false"
        tableCardTitle="Extraordinary Items"
        :tableModel="_colModel"
        :tableData="_extraordinaryData"
      ></table-view>
      <!--      Supplemental and Per Share Items-->
      <table-view
        :showPage="false"
        tableCardTitle="Supplemental and Per Share Items"
        :tableModel="_colModel"
        :tableData="_supplementalData"
      ></table-view>
      <!--  Cash Flow Statement  -->
      <div class="annualTitle">
        <span style="font-weight: bold">* Cash Flow Statement</span>
      </div>
      <!--      Cash Flows from Operating Activity-->
      <table-view
        :showPage="false"
        tableCardTitle="Cash Flows from Operating Activities"
        :tableModel="_colModel"
        :tableData="_operatingData"
      ></table-view>
      <!--    Cash Flows from Financing Activities  -->
      <table-view
        :showPage="false"
        tableCardTitle="Cash Flows from Financing Activities"
        :tableModel="_colModel"
        :tableData="_financingData"
      ></table-view>
      <!--     Supplemental Disclosures -->
      <table-view
        :showPage="false"
        tableCardTitle="Supplemental Disclosures"
        :tableModel="_colModel"
        :tableData="_disclosuresData"
      ></table-view>
      <!--  Ratios  -->
      <div class="annualTitle">
        <span style="font-weight: bold">* Income Statement</span>
      </div>
      <!--    ratios  -->
      <table-view
        :showPage="false"
        tableCardTitle="Performance ratios"
        :tableModel="_colModel"
        :tableData="_ratiosData"
      ></table-view>
      <!--      Liquidity ratios-->
      <table-view
        :showPage="false"
        tableCardTitle=" Liquidity ratios"
        :tableModel="_colModel"
        :tableData="_liquidityData"
      ></table-view>
      <!--      Efficiency ratios-->
      <table-view
        :showPage="false"
        tableCardTitle="Efficiency ratios"
        :tableModel="_colModel"
        :tableData="_effRatioData"
      ></table-view>
      <!--      Leverage ratios-->
      <table-view
        :showPage="false"
        tableCardTitle="Leverage ratios"
        :tableModel="_colModel"
        :tableData="_leverageData"
      ></table-view>
      <!--      long term obligations-->
      <table-view
        :showPage="false"
        tableCardTitle="Long Term Obligations"
        :tableModel="_colModel"
        :tableData="_longTermObligationData"
      ></table-view>
      <!--      Capital lease obligations-->
      <table-view
        :showPage="false"
        tableCardTitle="Capital lease obligations"
        :tableModel="_colModel"
        :tableData="_leaseObData"
      ></table-view>
      <!--      Operating Lease Obligations-->
      <table-view
        :showPage="false"
        tableCardTitle=" Operating Lease Obligations"
        :tableModel="_colModel"
        :tableData="_operatingOblData"
      ></table-view>
      <!--      Rate of Return-->
      <table-view
        :showPage="false"
        tableCardTitle="Rate of Return"
        :tableModel="_colModel"
        :tableData="_returnData"
      ></table-view>
    </el-card>
    <el-dialog
      :visible.sync="showDia"
      width="35%"
      title="Save To Financial Report"
    >
      <el-checkbox-group v-model="checkList">
        <el-checkbox
          v-for="year in colYears"
          :key="year"
          :label="year"
        ></el-checkbox>
      </el-checkbox-group>
      <el-form
        size="small"
        :inline="true"
        class="submitform"
        :model="form"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="Local Curreny">
          <el-select v-model="form.localCurreny" clearable filterable>
            <el-option
              v-for="item in pendingData"
              :key="item.currency"
              :label="item.currencyName"
              :value="item.currency"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Exchange Date" v-if="form.localCurreny !== 'USD'">
          <el-date-picker
            type="date"
            style="width: 90%"
            value-format="yyyy-MM-dd"
            v-model="form.exchangeDate"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="Exchange Rate(USD)"
          v-if="form.localCurreny !== 'USD'"
        >
          <el-input
            :disabled="true"
            v-model="form.exchangeRate"
            style="width: 83%"
          ></el-input>
        </el-form-item>
        <el-form-item label="Period Length">
          <el-select v-model="form.periodLength" placeholder="Select months" style="width: 100%">
            <el-option v-for="i in 12" :key="i" :label="i" :value="i"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">Cancel</el-button>
        <el-button type="primary" @click="this.handleConfirm">
          Confirm
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCrmFinancialReport,
  saveToFinancial,
  getCurrenyRate,
} from '../../api'
import { getCurrencyList } from '@/api'
import ScoreBar from '../ckr-report/components/score-bar'
import mixins from './mixins'

export default {
  name: 'crm-financial-report',
  mixins: [mixins],
  components: { ScoreBar },
  data() {
    const ZscoreOption = {
      title: {
        text: "Z'Score",
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985',
          },
        },
      },
      xAxis: {
        type: 'category',
        data: [],
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          data: [],
          type: 'line',
        },
      ],
    }
    const option = {
      title: {
        text: 'Frisk Score',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985',
          },
        },
      },
      xAxis: {
        type: 'category',
        data: [],
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          data: [],
          type: 'line',
        },
      ],
    }
    return {
      pendingData: [],
      ZscoreOption,
      form: {
        localCurreny: '',
        exchangeDate: '',
        exchangeRate: '',
        periodLength: 12,
      },
      rules: {
        periodLength: [
          { required: true, message: 'Please select period length', trigger: 'change' },
        ],
      },
      showDia: false,
      checkList: [],
      option,
      radio: '',
      detail: {},
      friskHistorySchema: [
        { prop: 'date', label: 'Date' },
        { prop: 'zscore', label: "Z'Score history" },
      ],
      // table
      // current assets
      colYears: [], // column 纵向
      currentAssetData: [],

      currentAssetKeys: [
        'cashandShortTermInvestments',
        'accountsReceivable',
        'notesReceivableShortTerm',
        'otherReceivables',
        'inventory',
        'prepaidExpenses',
        'otherCurrentAssetsTotal',
        'totalCurrentAssets',
      ],
      nonCurrentAssetKeys: [
        'propertyPlantEquipment',
        'goodwillNet',
        'intangiblesNet',
        'longTermInvestments',
        'noteReceivableLongTerm',
        'otherAssetsTotal',
        'otherLongTermAssetsTotal',
        'totalAssets',
      ],
      currentLiabilityKeys: [
        'accountsPayable',
        'accruedExpenses',
        'notesPayableShortTermDebt',
        'currentPortLtDebtCapitalLeases',
        'otherCurrentLiabilitiesTotal',
        'totalCurrentLiabilities',
      ],
      nonCurrentLiabilities: [
        'totalLongTermDebt',
        'capitalLeaseObligations',
        'deferredIncomeTax',
        'cminorityInterest',
        'otherLiabilitiesTotal',
        'totalLiabilities',
      ],
      shareHolderKeys: [
        'commonStock',
        'additionalPaidInCapital',
        'retainedEarnings',
        'treasuryStockCommon',
        'otherEquityTotal',
        'totalEquity',
        'totalLiabilitiesShareholdersEquity',
      ],
      suppleKeys: ['totalCommonSharesOutstanding'],
      // income keys
      revenueKeys: ['revenue', 'totalSales'],
      expenseKeys: [
        'costOfGoods',
        'sga',
        'depreciationAmortization',
        'otherOperatingExpensesTotal',
        'totalOperatingExpense',
        'unusualIncomeExpense',
        'operatingIncome',
      ],
      noeiKeys: [
        'interestExpenseNetNonOperating',
        'interestInvestmentIncomeNonOperating',
        'otherNet',
        'incomeBeforeTax',
        'incomeTaxTotal',
        'incomeAfterTax',
        'iminorityInterest',
      ],
      extraordinaryKeys: ['totalExtraordinaryItems', 'netIncome'],
      spmentKeys: [
        'basicPrimaryEpsInclExtraItems',
        'dilutedEpsInclExtraItems',
        'interestExpenseSupplemental',
        'interestCapitalizedSupplemental',
        'depreciationAmortizationSupplemental',
      ],
      // cash flow
      operatingKeys: [
        'cnetIncome',
        'depreciationDepletion',
        'nonCashItems',
        'changesInWorkingCapital',
        'netCashOperating',
        'capitalExpenditures',
        'otherInvestingCashFlowItemsTotal',
        'totalCashFromInvestingActivities',
      ],
      financingKeys: [
        'financingCashFlowItems',
        'totalCashDividendsPaid',
        'issuanceRetirementOfStockNet',
        'issuanceRetirementOfDebtNet',
        'totalCashFromFinancingActivities',
        'foreignExchangeEffects',
        'netChangeInCash',
        'netCashBeginningBalance',
        'netCashEndingBalance',
      ],
      disclosureKeys: ['cashInterestPaid', 'cashTaxesPaid'],
      // performance
      rationKeys: [
        'grossMargin',
        'sgaOfSales',
        'operatingMarginOfSales',
        'ebitdaMarginOfSales',
        'pretaxIncomeOfSales',
        'netProfitMarginOfSales',
        'incomeTaxOfPretaxIncome',
        'depreciationOfCapEx',
        'depreciationOfPpe',
        'capitalExpenseOfPpe',
        'capExOfWorkingCap',
        'timesInterestEarned',
        'freeCashFlow',
      ],
      liquidityKeys: [
        'currentAssetsOfDebt',
        'workingCapital',
        'workingCapitalOfSales',
        'cashOfDebt',
        'cashRatio',
        'quickAssets',
        'quickAssetsOfDebt',
        'quickRatio',
        'currentRatio',
      ],
      effRatioKeys: [
        'arOfSales',
        'arTurnover',
        'daysSalesOutstanding',
        'inventoryFinanced',
        'inventoryTurnover',
        'daysSalesInventory',
        'inventoryWorkingCapital',
        'apTurnover',
      ],
      leverageKeys: [
        'debtAssetsRatio',
        'debtEquityRatio',
        'debtTangibleNetWorthRatio',
        'liabilitiesEquityRatio',
        'liabilitiesNetWorthRatio',
        'netTangibleAssets',
        'shortTermDebt',
        'shortTermDebtOfDebt',
        'shortTermDebtOfWorkingCapital',
        'tangibleNetWorth',
        'tierOneCapitalPercent',
        'totalCapitalPercent',
        'totalDebt',
      ],
      obligationKeys: [
        'longTermDebt1',
        'longTermDebt2',
        'longTermDebt3',
        'longTermDebt4',
        'longTermDebt5',
        'longTermDebtRemaining',
        'totalLongTermDebtSupp',
      ],
      leaseObjKeys: [
        'capitalLeases1',
        'capitalLeases2',
        'capitalLeases3',
        'capitalLeases4',
        'capitalLeases5',
        'longTermDebtRemaining',
        'totalCapitalLeases',
      ],
      operaingOblKeys: [
        'operatingLeases1',
        'operatingLeases2',
        'operatingLeases3',
        'operatingLeases4',
        'operatingLeases5',
        'operatingLeasesRemaining',
        'totalOperatingLeases',
        'cumulativeObligations3',
      ],
      returnKeys: [
        'returnOnEquity',
        // 'returnOnTangibleNetworth',
        'returnOnNetAssets',
        'returnOnTangibleNetworth',
        // 'ttmDividends',
        'returnOnAssets',
      ],
    }
  },
  computed: {
    friskScore() {
      return this.detail.businessVO && Number(this.detail.businessVO.friskScore)
    },
    _generalData() {
      // 只需要显示以下字段
      const _keys = [
        'name',
        'businessId',
        'tickerSymbol',
        'latestStatementDate',
      ]
      return this.handleCommon(_keys, this.detail.businessVO)
    },
    _contactData() {
      // 只需要显示以下字段
      const _keys = [
        'phoneNumber',
        'webSite',
        'marketCap',
        'employees',
        'emailAddress',
        'employeesAsOfDate',
        'federalTaxId',
        'cikNumber',
        'tickerSymbol',
        'stockExchange',
      ]
      return this.handleCommon(_keys, this.detail.businessVO)
    },
    // table
    // current assets
    _colModel() {
      const _res = [{ label: '', prop: '__name' }]
      this.colYears.forEach(item => {
        _res.push({
          label: `${item}`,
          prop: `annual${item}`,
        })
      })
      return _res
    },
    _currentAssetData() {
      // 根据需要的key摘取数据
      return this.handleCommonTable('balanceVO', this.currentAssetKeys)
    },
    _nonCurrentAsset() {
      return this.handleCommonTable('balanceVO', this.nonCurrentAssetKeys)
    },
    _currentLiabilities() {
      return this.handleCommonTable('balanceVO', this.currentLiabilityKeys)
    },
    _nonCurrentLiabilities() {
      return this.handleCommonTable('balanceVO', this.nonCurrentLiabilities)
    },
    _shareHolders() {
      return this.handleCommonTable('balanceVO', this.shareHolderKeys)
    },
    _suppleData() {
      return this.handleCommonTable('balanceVO', this.suppleKeys)
    },
    _revenueData() {
      return this.handleCommonTable('incomeVO', this.revenueKeys)
    },
    _expenseData() {
      return this.handleCommonTable('incomeVO', this.expenseKeys)
    },
    _noeiData() {
      return this.handleCommonTable('incomeVO', this.noeiKeys)
    },
    _extraordinaryData() {
      return this.handleCommonTable('incomeVO', this.extraordinaryKeys)
    },
    _supplementalData() {
      return this.handleCommonTable('incomeVO', this.spmentKeys)
    },
    _operatingData() {
      return this.handleCommonTable('cashflowVO', this.operatingKeys)
    },
    _financingData() {
      return this.handleCommonTable('cashflowVO', this.financingKeys)
    },
    _disclosuresData() {
      return this.handleCommonTable('cashflowVO', this.disclosureKeys)
    },
    _ratiosData() {
      return this.handleCommonTable('performanceVO', this.rationKeys)
    },
    _liquidityData() {
      return this.handleCommonTable('liquidityVO', this.liquidityKeys)
    },
    _effRatioData() {
      return this.handleCommonTable('efficiencyVO', this.effRatioKeys)
    },
    _leverageData() {
      return this.handleCommonTable('leverageVO', this.leverageKeys)
    },
    _longTermObligationData() {
      return this.handleCommonTable('obligationsVO', this.obligationKeys)
    },
    _leaseObData() {
      return this.handleCommonTable('obligationsVO', this.leaseObjKeys)
    },
    _operatingOblData() {
      return this.handleCommonTable('obligationsVO', this.operaingOblKeys)
    },
    _returnData() {
      return this.handleCommonTable('returnVO', this.returnKeys)
    },
  },
  watch: {
    'form.localCurreny': {
      handler(newVal) {
        if (newVal && this.form.exchangeDate) {
          this._getCurrenyRate()
        }
      },
    },
    'form.exchangeDate': {
      handler(newVal) {
        if (newVal && this.form.localCurreny) {
          this._getCurrenyRate()
        }
      },
    },
  },
  mounted() {
    this._getCrmDetailDetail()
    this._getCurrenyList()
  },
  methods: {
    // handleSubmit() {
    //   if (this.radio) {
    //     this.$router.push({
    //       name: 'bureau-report-add',
    //       params: { customerId: this.$route.params.customerId },
    //       query: {
    //         businessId: this.radio,
    //       },
    //     })
    //   } else {
    //     this.$message.warning('Please select')
    //   }
    // },

    async _getCurrenyList() {
      this.pendingData = await getCurrencyList()
    },
    // 接口数据
    async _getCrmDetailDetail() {
      try {
        const { id } = this.$store.state.bureauReportBasicInfo
        this.detail = await getCrmFinancialReport(id)
        // statements table column
        if (this.detail) {
          this.detail.statementsVOList.map(item => {
            if (item.baseVO.statementQuarter === '0') {
              this.colYears = this.detail.statementsVOList.map(
                item =>
                  item.baseVO.statementYear +
                  ` (` +
                  item.baseVO.currencyCode +
                  `)`,
              )
            } else {
              this.colYears = this.detail.statementsVOList.map(
                item =>
                  item.baseVO.statementYear +
                  ` Q` +
                  item.baseVO.statementQuarter +
                  ` (` +
                  item.baseVO.currencyCode +
                  `)`,
              )
            }
          })
        }
        // Z-score
        const ZxData =
          this.detail.zscoreHistoryVOList &&
          this.detail.zscoreHistoryVOList.map(item => item.date)
        const ZyData =
          this.detail.zscoreHistoryVOList &&
          this.detail.zscoreHistoryVOList.map(item => item.zscore)
        this.ZscoreOption = {
          ...this.ZscoreOption,
          xAxis: {
            ...this.ZscoreOption.xAxis,
            data: ZxData,
          },
          series: [
            {
              type: 'line',
              data: ZyData,
            },
          ],
        }
        // frisk echart options
        const xData =
          this.detail && this.detail.friskhistoryVOList.map(item => item.date)
        const yData =
          this.detail &&
          this.detail.friskhistoryVOList.map(item => item.averageFriskScore)
        this.option = {
          ...this.option,
          xAxis: {
            ...this.option.xAxis,
            data: xData,
          },
          series: [
            {
              type: 'line',
              data: yData,
            },
          ],
        }
      } catch (err) {
        console.error(err)
      }
    },
    // 把公共逻辑抽出来
    handleCommon(neededKeys, sourceDataObj = {}) {
      const _res = {}
      const _detailKeys = Object.keys(sourceDataObj) || []
      _detailKeys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(sourceDataObj, `${key}Str`)) {
          delete sourceDataObj[key]
        }
      })
      // 处理多余字段
      for (const key of neededKeys) {
        if (_detailKeys.indexOf(key) !== -1) {
          _res[key] = sourceDataObj[key]
        }
      }
      return this.handleInfoData(_res)
    },
    handleInfoData(apiData) {
      if (apiData) {
        return Object.keys(apiData).map(key => ({
          key: mixins.methods.transKeyToLabel(key),
          value: apiData[key],
        }))
      }
      return []
    },
    transTbData(sourceData) {
      const _arr = []
      if (!sourceData.length) {
        return []
      } else {
        const len = Object.keys(sourceData[0].data)?.length
        for (let i = 0; i < len; i++) {
          const _obj = {}
          for (let j = 0; j < sourceData.length; j++) {
            const key = Object.keys(sourceData[j].data)[i]
            ;(_obj['__name'] = mixins.methods.transKeyToLabel(key)),
              (_obj[`annual${sourceData[j].year}`] =
                typeof Number(sourceData[j].data[key]) === 'number'
                  ? this.$utils.formatAmount(sourceData[j].data[key])
                  : sourceData[j].data[key])
          }
          _arr.push(_obj)
        }
      }
      return _arr
    },
    handleCommonTable(taleName, showKeys) {
      const _res = []
      if (
        this.detail &&
        this.detail.statementsVOList &&
        this.detail.statementsVOList.length
      ) {
        this.detail.statementsVOList.forEach(item => {
          const _obj = {}
          Object.keys(item[taleName]).forEach(key => {
            if (showKeys.indexOf(key) !== -1) {
              _obj[key] = item[taleName][key]
            }
          })
          _res.push(_obj)
        })
      }
      for (let i = this.colYears.length - 1; i >= 0; i--) {
        if (_res.length) {
          _res[i]['year'] = this.colYears[i]
        }
      }
      // 处理成需要的数据结构
      for (let i = 0; i < _res.length; i++) {
        _res[i]['data'] = {}
        for (const _key of showKeys) {
          _res[i]['data'][_key] = _res[i][_key]
          delete _res[i][_key]
        }
      }
      return this.transTbData(_res)
    },
    // 获取汇率
    async _getCurrenyRate() {
      const { rate } = await getCurrenyRate(
        this.form.exchangeDate,
        this.form.localCurreny,
      )
      this.form.exchangeRate = rate
    },
    async handleConfirm() {
      try {
        const valid = await new Promise(resolve => {
          this.$refs.ruleForm.validate(v => resolve(v))
        })
        if (!valid) return
        const params = {
          bureauReportId: this.$store.state.bureauReportBasicInfo.id,
          companyId: this.$route.params.customerId,
          statementYears: this.checkList.map(item => {
            if (item.indexOf('Q3') !== -1) {
              item = item.replace(/ Q3/g, -3).substring(0, 6)
            } else if (item.indexOf('Q2') !== -1) {
              item = item.replace(/ Q2/g, -2).substring(0, 6)
            } else if (item.indexOf('Q1') !== -1) {
              item = item.replace(/ Q1/g, -1).substring(0, 6)
            } else if (item.indexOf('Q4') !== -1) {
              item = item.replace(/ Q4/g, -4).substring(0, 6)
            } else {
              item = item.substring(0, 4)
            }
            return item
          }),
          rate: this.form.localCurreny === 'USD' ? '1' : this.form.exchangeRate,
          periodLength: this.form.periodLength,
        }
        await saveToFinancial(params)
        this.$message.success('success')
        this.showDia = false
        this.checkList = []
      } catch (err) {
        console.error(err)
      }
    },
    handleCancel() {
      this.checkList = []
      this.form.exchangeDate = ''
      this.form.localCurreny = ''
      this.form.exchangeRate = ''
      this.showDia = false
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  .card {
    width: 100%;
    margin-bottom: 24px;

    .annualTitle {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    :deep(.table-header) {
      th {
        background-color: #f5f5fa;
        height: 56px;
        font-size: 14px;
        color: #000;
        line-height: 20px;
      }
    }

    .scoreBox {
      width: 100%;
      height: 100%;
      font-size: 14px;
      display: flex;

      .leftBox {
        width: 50%;
        box-sizing: border-box;
        padding-right: 20px;
        padding-top: 20px;

        & > div {
          & > p {
            display: flex;
            margin-bottom: 10px;
            justify-content: space-between;
          }
        }
      }
      .rightBox {
        padding-left: 20px;
        box-sizing: border-box;
        width: 50%;
        height: 100%;
        .echartBox {
          display: inline-block;
          width: 33%;
        }
      }
    }
  }
}
.submitform {
  margin-top: 30px;
}
</style>
